import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import * as api from "api"
import { getDirection } from "common/utils/formatters"
import { memo } from "react"

const Styled = {
  Grid: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    margin: 20px 0 30px;
    gap: 35px;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 30px 0;
    }
  `,
  Option: styled.div`
    display: flex;
    flex-direction: column-reverse;
    gap: 15px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      flex: 1;
      flex-direction: column;
    }
  `,
  Title: styled(Typography)`
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 24px;
      font-weight: 500;
    }
  `,
  Value: styled(Typography)<{ direction: "ltr" | "rtl" }>`
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
    direction: ${(p) =>
      p.direction === "rtl" ? "ltr" : "rtl"}; /* mui flips the direction */
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 58px;
      font-weight: bold;
    }
  `,
  Unit: styled.span`
    font-size: 18px;
    font-weight: bold;
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 34px;
    }
  `,
}

type VehicleFreeOptionsProps = { data: api.DynamicRowWithUnits[] }

const VehicleFreeOptions = ({ data }: VehicleFreeOptionsProps) => (
  <Styled.Grid>
    {data.map((row, i) => (
      <Styled.Option key={i}>
        <Styled.Title>{row.title}</Styled.Title>
        <Styled.Value direction={getDirection(row.measurementUnit)}>
          {row.description} <Styled.Unit>{row.measurementUnit}</Styled.Unit>
        </Styled.Value>
      </Styled.Option>
    ))}
  </Styled.Grid>
)

export default memo(VehicleFreeOptions)
